import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { StyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';

import './ExpandableText.css';

interface ExpandableTextProps {
    content: React.ReactNode;
    shortContent: React.ReactNode;
    openedStateSwitcherText: string;
    closedStateSwitcherText: string;
}

interface ExpandableTextState {
    isOpen: boolean;
}

export class ExpandableText extends React.Component<ExpandableTextProps, ExpandableTextState> {
    constructor(props: ExpandableTextProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    render() {
        const { isOpen } = this.state;
        const { shortContent, content, openedStateSwitcherText, closedStateSwitcherText } = this.props;

        return (
            <>
                <div className={Bem.cls('expandable-text', 'text')}>{isOpen ? content : shortContent}</div>

                <StyledLink
                    theme={StyledLinkTheme.grey}
                    cls={classNames(Bem.cls('expandable-text', 'switcher'), TestBem.cls('expandable-text', 'switcher'))}
                    onClick={this.switchOpenState}
                >
                    {isOpen ? openedStateSwitcherText : closedStateSwitcherText}

                    <Shape2
                        cls={Bem.cls({
                            block: 'expandable-text',
                            elem: 'switcher-icon',
                            mods: { opened: isOpen }
                        })}
                        width={12}
                        height={12}
                        icon={Shape2Icon.verticalArrow}
                    />
                </StyledLink>
            </>
        );
    }

    private switchOpenState = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };
}
